import { cn } from '@lib/cn'
import { FC, PropsWithChildren } from 'react'

type MenuListProps = PropsWithChildren<{
  space: 'large' | 'regular' | 'small'
}>

export const MenuList: FC<MenuListProps> = ({ space, children }) => {
  return (
    <ul
      data-space={space}
      className={cn(
        'm-0 p-0',
        space === 'small' && '[&>li]:mb-4',
        space === 'regular' && '[&>li]:mb-6',
        space === 'large' && '[&>li]:mb-8',
      )}
    >
      {children}
    </ul>
  )
}
